// Lo que la pantalla dice despues de consultar el padron — iniciativa AC,
// RN-188, RN-189. SPEC_RUC_VERIFICADO_CONTRA_PADRON_v0.1.md.
//
// La barrera real es el backend (`verificacionRucService`, RN-190): esto
// adelanta el aviso para que el operador lo vea al salir del campo y no al
// apretar Guardar.
//
// Se consulta el padron por la BASE, sin DV: el loader, con DV, filtra por los
// dos, y un digito mal tipeado volvia como «no figura» en vez de decir cual es
// el correcto.

// `5539104-2` -> { base: '5539104', dv: '2' }. Sin DV, `dv` es null.
export function partirRuc (valor) {
  const texto = String(valor || '').replace(/\s+/g, '')
  const guion = texto.indexOf('-')
  if (guion === -1) return { base: texto, dv: null }
  return { base: texto.slice(0, guion), dv: texto.slice(guion + 1) || null }
}

// RN-195. Un nombre que es un numero de documento (`3829909-0` como razon
// social) no es un nombre. Misma regla que `nombrePareceDocumento` del API.
export function nombrePareceDocumento (nombre) {
  const texto = String(nombre || '').trim()
  return texto !== '' && /^[\d\s.-]+$/.test(texto)
}

// Solo un RUC con DV se verifica: una cedula sin DV factura como cedula.
export function esRucConDv (valor) {
  const { base, dv } = partirRuc(valor)
  return /^\d{1,20}$/.test(base) && dv !== null && /^\d{1,2}$/.test(dv)
}

/**
 * @param {string} tecleado        lo que escribio el operador
 * @param {string|null} rucPadron  el RUC que devolvio el padron, o null si no figura
 * @returns {{estado: 'CONFIRMADO'|'CORREGIDO'|'NO_FIGURA'|'SIN_DV', documento?: string, cedula?: string, mensaje: string}}
 */
export function avisoDePadron (tecleado, rucPadron) {
  const conDv = esRucConDv(tecleado)
  const { base, dv } = partirRuc(tecleado)

  if (!rucPadron) {
    if (!conDv) {
      return { estado: 'SIN_DV', mensaje: 'No figura en el padrón de la DNIT: cargá los datos a mano.' }
    }
    return {
      estado: 'NO_FIGURA',
      cedula: base,
      mensaje: `El RUC ${base}-${dv} no figura en el padrón de la DNIT, con ningún dígito verificador: `
        + 'SIFEN rechazaría la factura. Si la persona no tiene RUC, registrala con su cédula.'
    }
  }

  const delPadron = partirRuc(rucPadron)
  if (conDv && Number(delPadron.dv) !== Number(dv)) {
    return {
      estado: 'CORREGIDO',
      documento: rucPadron,
      mensaje: `El dígito verificador de ${base}-${dv} no es correcto: según el padrón es ${rucPadron}. `
        + 'Se corrigió.'
    }
  }
  return { estado: 'CONFIRMADO', documento: rucPadron, mensaje: '' }
}
